import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { fallback?: (error: Error, reset: () => void) => ReactNode; children: ReactNode }
interface State { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('ErrorBoundary', error, info.componentStack); }
  reset = () => this.setState({ error: null });
  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback) return this.props.fallback(this.state.error, this.reset);
    return (
      <div className="card"><div className="card-body">
        <div className="page-title">Something went wrong</div>
        <p style={{ color: 'var(--text-secondary)' }}>{this.state.error.message}</p>
        <button type="button" className="btn btn-primary btn-sm" onClick={this.reset}>Try again</button>
      </div></div>
    );
  }
}
